import { AmountOffCouponBase } from '../amount-off/amount-off-base';
import { Util } from "../../../../util/util";
export class PercentAmountOffEntireOrderCoupon extends AmountOffCouponBase {
    constructor(appType, sourceData, deps, baseData, identity) {
        super(appType, sourceData, deps, baseData, identity);
    }
    getDiscountItems(cart) {
        const discountItems = [];
        for (const [index, oItem] of cart.items.entries()) {
            const availableQuantity = oItem.quantity - Util.GetBlockedQuantity(cart, oItem, this.allowOtherCoupons);
            if (availableQuantity <= 0 || (this.isLoyaltyExcluded && oItem.isRedeemed)) {
                continue;
            }
            oItem.discountedMarkedQuantity += availableQuantity; // Notice: This modifies the passed oItem directly.
            for (let i = 0; i < availableQuantity; i++) {
                const dItem = {
                    itemArrayIndex: index,
                    cPrice: 0, // For percent off entire order, the discount amount is calculated at the end, so cPrice is set to 0 here.
                    oPrice: oItem.price,
                    itemKey: oItem.itemKey,
                    halfIndex: oItem.halfIndex,
                    halfCount: oItem.halfCount,
                    itemRecId: oItem.itemRecId,
                    addOn: 0,
                    beforeTaxDiscount: 0,
                    afterTaxDiscount: 0
                };
                discountItems.push(dItem);
            }
        }
        return discountItems;
    }
    computeDiscountAmount(_, cart) {
        let amt = (cart.subtotal - cart.discount) * (this._discountAmount / 100);
        amt = this._adjustDiscountAmount(cart, amt);
        return amt;
    }
}
//# sourceMappingURL=percent-amount-off-entire-order.js.map